import { useEffect } from 'react';
import { H2 } from '@bigcommerce/big-design';

import { useHelp } from './HelpContext';

const ToolPage = ({ children, title, description, helpLink, noHelp }) => {
  const { setHelp } = useHelp();

  useEffect(() => {
    if (!noHelp) {
      setHelp({ title, description, helpLink });
    }

    return () => {
      if (!noHelp) {
        setHelp(null);
      }
    };
  }, []);

  return (
    <div className="tool-page">
      { title && <H2>{title}</H2> }
      {children}
    </div>
  );
}

export default ToolPage;
